import { render, staticRenderFns } from "./InstitutionPageCustom.vue?vue&type=template&id=76853726&"
import script from "./InstitutionPageCustom.vue?vue&type=script&lang=js&"
export * from "./InstitutionPageCustom.vue?vue&type=script&lang=js&"
import style0 from "./InstitutionPageCustom.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports